<h1 mat-dialog-title>Dateien f&uuml;r Befundmitteilung {{ befundmitteilung?.tagebuch_nr }}</h1>
<div mat-dialog-content>
    <mat-list cdkDropList (cdkDropListDropped)="dropPosition($event)" [cdkDropListDisabled]="isSaving">
        <mat-list-item *ngFor="let eb of externeBefunde; let i = index" [cdkDragData]="eb" cdkDrag cdkDragLockAxis="y">
            <div mat-line>
                <div class="one-row">
                    <mat-icon cdkDragHandle>menu</mat-icon>
                    <mat-icon mat-list-icon>insert_drive_file</mat-icon>
                    <p style="cursor: pointer" (click)="openFile(eb)">{{ eb.dateiname }}</p>
                    <kiene-delete-button
                        *kienePermission="[1324]"
                        (delete)="delete(eb, i)"
                        [disabled]="isSaving"
                    ></kiene-delete-button>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close()">Schlie&szlig;en</button>
</div>
